import { useFormContext } from "react-hook-form";
import InputField from "@medoma/components/InputField/InputField";
import { useLingui } from "@lingui/react/macro";
import type { LocalizedPhoneNumber } from "@medoma/models/phoneNumbers";

export type PhoneNumberInputFields = {
  phoneNumber: LocalizedPhoneNumber;
};

const PhoneNumberInput = ({ isRequired }: { isRequired: boolean }) => {
  const {
    register,
    formState: { errors },
  } = useFormContext<PhoneNumberInputFields>();
  const { t } = useLingui();

  return (
    <InputField
      type="tel"
      {...register("phoneNumber", {
        required: {
          value: isRequired,
          message: t`Ange telefonnummer`,
        },
        pattern: {
          value: /^([0-9]|\s)+$/,
          message: t`Telefonnumret får bara innehålla siffror`,
        },
      })}
      label={t`Telefonnummer`}
      showOptionalLabel={!isRequired}
      errorMessage={errors.phoneNumber?.message}
    />
  );
};

export default PhoneNumberInput;
